export default "__VITE_ASSET__BuMpzch6__"